(function () {
  // Contador regresivo de liquidación
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var target = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(target)) return;
    var d = el.querySelector('.cd-d'), h = el.querySelector('.cd-h'), m = el.querySelector('.cd-m'), s = el.querySelector('.cd-s');
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var diff = target - Date.now();
      // Al llegar a cero se oculta (nunca "Promoción finalizada": eso espanta la venta)
      if (diff <= 0) { el.hidden = true; el.style.display = 'none'; return; }
      if (d) d.textContent = Math.floor(diff / 86400000);
      if (h) h.textContent = pad(Math.floor(diff % 86400000 / 3600000));
      if (m) m.textContent = pad(Math.floor(diff % 3600000 / 60000));
      if (s) s.textContent = pad(Math.floor(diff % 60000 / 1000));
    }
    tick();
    setInterval(tick, 1000);
  });

  // Celular (html.motion-lite, sin GSAP): entrada suave al aparecer en pantalla. Solo se marca lo
  // que todavía está abajo del pliegue, así nada visible parpadea; sin JS todo queda visible.
  if (document.documentElement.classList.contains('motion-lite') && 'IntersectionObserver' in window) {
    var rvIo = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('rv-in'); rvIo.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('[data-pcard], [data-sc-card], [data-lb-item], [data-rv], .mt-item, .gema-stats, .fb-quote, .bd-in').forEach(function (el) {
      if (el.getBoundingClientRect().top > window.innerHeight) { el.classList.add('rvl'); rvIo.observe(el); }
    });
  }

  // Hero: forzar reproducción del video aunque el navegador bloquee el autoplay
  // (modo bajo consumo, "reducir movimiento", ahorro de datos, etc.)
  var heroVid = document.querySelector('.hero-photo video');
  if (heroVid) {
    var gestures = ['touchstart', 'pointerdown', 'scroll', 'click', 'keydown'];
    var tryPlay = function () {
      if (heroVid.paused) {
        var p = heroVid.play();
        if (p && p.catch) p.catch(function () {});
      }
    };
    // Deja de escuchar gestos solo cuando el video ya está reproduciéndose de verdad
    var cleanup = function () {
      gestures.forEach(function (ev) { window.removeEventListener(ev, kick); });
    };
    var kick = function () {
      tryPlay();
      // confirma un instante después; si ya corre, deja de escuchar
      setTimeout(function () { if (!heroVid.paused) cleanup(); }, 250);
    };
    tryPlay();
    heroVid.addEventListener('canplay', tryPlay);
    heroVid.addEventListener('loadeddata', tryPlay);
    heroVid.addEventListener('playing', function () { if (!heroVid.paused) cleanup(); });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) tryPlay();
    });
    gestures.forEach(function (ev) {
      window.addEventListener(ev, kick, { passive: true });
    });
  }

  // Menú hamburguesa
  var burger = document.querySelector('.burger');
  var mnav = document.getElementById('mnav');
  if (burger && mnav) {
    var cerrarMenu = function () {
      mnav.classList.remove('open');
      burger.classList.remove('open');
      burger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('nav-lock');
      if (window.__lenis) window.__lenis.start();
    };
    burger.addEventListener('click', function () {
      var open = mnav.classList.toggle('open');
      burger.classList.toggle('open', open);
      burger.setAttribute('aria-expanded', open);
      document.body.classList.toggle('nav-lock', open);
      if (window.__lenis) { if (open) window.__lenis.stop(); else window.__lenis.start(); }
      if (open) mnav.scrollTop = 0;
    });
    // Botón X propio del menú: el del header queda fuera de pantalla al hacer scroll en la home
    var equis = mnav.querySelector('.mnav-x');
    if (equis) equis.addEventListener('click', cerrarMenu);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mnav.classList.contains('open')) cerrarMenu();
    });
    mnav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', cerrarMenu);
    });
  }

  // Revela elementos al hacer scroll + contadores animados
  document.querySelectorAll('.pcard, .edi-text h2, .edi-text p, .fb-quote, .tiktok .mini, .tiktok h2, .tiktok p, .tiktok .btn-oro, .foot-grid > div')
    .forEach(function (el) { el.classList.add('rv'); });

  document.querySelectorAll('.row, .pgrid').forEach(function (row) {
    row.querySelectorAll('.pcard').forEach(function (c, i) { c.style.setProperty('--d', (i * 0.09) + 's'); });
  });
  document.querySelectorAll('.edi-text, .tiktok, .foot-grid').forEach(function (box) {
    box.querySelectorAll('.rv').forEach(function (el, i) { el.style.setProperty('--d', (i * 0.12) + 's'); });
  });

  // El número final ya viene impreso desde el servidor; esto solo lo anima.
  // Si el usuario pidió "reducir movimiento", se deja tal cual y no se toca.
  var sinMovimiento = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function count(el) {
    var target = +el.dataset.count, dur = 1600, t0 = performance.now();
    if (sinMovimiento || isNaN(target)) { el.textContent = isNaN(target) ? el.textContent : target; return; }
    function tick(t) {
      var p = Math.min((t - t0) / dur, 1);
      var ease = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * ease);
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('in');
      e.target.querySelectorAll('[data-count]:not(.done)').forEach(function (n) { n.classList.add('done'); count(n); });
      io.unobserve(e.target);
    });
  }, { threshold: 0.18 });

  document.querySelectorAll('.rv, .ghost-head, .stat').forEach(function (el) { io.observe(el); });

  // Comprar ahora: agrega el producto y va directo al checkout
  var buyNow = document.querySelector('.buy-now');
  if (buyNow) {
    buyNow.addEventListener('click', function () {
      var form = buyNow.closest('form');
      if (!form) return;
      buyNow.disabled = true;
      buyNow.textContent = 'Un momento…';
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = '/checkout';
        })
        .catch(function () {
          buyNow.disabled = false;
          buyNow.textContent = 'Comprar ahora';
          form.submit();
        });
    });
  }

  // Carrito: actualizar cantidades automáticamente al cambiarlas
  document.querySelectorAll('.cart-qty').forEach(function (input) {
    input.addEventListener('change', function () {
      if (input.form) input.form.submit();
    });
  });

  // Filas de productos.
  // Touch: se maneja 100% con scroll nativo (CSS touch-action: pan-x) — suave y sin
  // arrastrar la página en vertical. Aquí solo agregamos, para escritorio:
  //  · arrastrar con el mouse (click y jala) para desplazar la fila
  //  · rueda vertical del mouse -> desplaza horizontal, cediendo a la página en los bordes
  document.querySelectorAll('.row').forEach(function (row) {
    // — Arrastrar con MOUSE únicamente (en touch: scroll nativo, el tap siempre navega) —
    var isDown = false, moved = false, startX = 0, startScroll = 0;
    row.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return; // touch/lápiz: no intervenir
      isDown = true; moved = false;
      startX = e.clientX; startScroll = row.scrollLeft;
    });
    row.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 5) { moved = true; row.classList.add('dragging'); }
      if (moved) row.scrollLeft = startScroll - dx;
    });
    function endDrag() {
      isDown = false;
      // quita 'dragging' en el siguiente tick para que el click ya haya pasado
      requestAnimationFrame(function () { row.classList.remove('dragging'); });
    }
    row.addEventListener('pointerup', endDrag);
    row.addEventListener('pointercancel', endDrag);
    row.addEventListener('pointerleave', function () { if (isDown) endDrag(); });
    // Suprime el click SOLO si de verdad hubo un arrastre con mouse
    row.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);

    // — Rueda vertical del mouse -> horizontal (cede a la página en los bordes) —
    row.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
      var atStart = row.scrollLeft <= 0;
      var atEnd = row.scrollLeft + row.clientWidth >= row.scrollWidth - 1;
      if ((e.deltaY < 0 && atStart) || (e.deltaY > 0 && atEnd)) return;
      e.preventDefault();
      row.scrollLeft += e.deltaY;
    }, { passive: false });
  });

  // ── Upsell del carrito: agregar sin salir de la página ──
  // Se recarga al terminar porque hay que recalcular totales, descuentos y la barra de envío.
  document.querySelectorAll('.up-form:not([data-quick-add])').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = f.querySelector('button');
      var txt = btn.textContent;
      btn.disabled = true;
      btn.textContent = '\u2026';
      fetch('/cart/add.js', { method: 'POST', body: new FormData(f) })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.reload();
        })
        .catch(function () {
          // Si el AJAX falla, se deja que el formulario haga su envío normal
          btn.disabled = false;
          btn.textContent = txt;
          f.submit();
        });
    });
  });

  // ── Barra de avisos rotativa ──
  var barra = document.querySelector('.announce[data-rotar]');
  if (barra) {
    var avisos = barra.querySelectorAll('span');
    if (avisos.length > 1) {
      var actual = 0;
      setInterval(function () {
        avisos[actual].classList.remove('on');
        actual = (actual + 1) % avisos.length;
        avisos[actual].classList.add('on');
      }, 4000);
    }
  }

  // ── El botón de WhatsApp no debe encimarse con el badge de reCAPTCHA ──
  // El badge lo inyecta Shopify después de cargar, así que hay que esperarlo.
  var flotante = document.querySelector('.wa-float');
  if (flotante) {
    var acomodar = function () {
      var badge = document.querySelector('.grecaptcha-badge');
      // Ojo: offsetParent es SIEMPRE null en position:fixed —y el badge lo es—, así que
      // hay que medirlo con getBoundingClientRect en vez de con offsetParent.
      var visible = false;
      if (badge) {
        var caja = badge.getBoundingClientRect();
        visible = caja.width > 0 && caja.height > 0 && getComputedStyle(badge).visibility !== 'hidden';
      }
      flotante.classList.toggle('sube', visible);
      return visible;
    };
    if (!acomodar()) {
      // Vigila la llegada del badge y deja de observar en cuanto lo acomoda
      var obs = new MutationObserver(function () { if (acomodar()) obs.disconnect(); });
      obs.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { obs.disconnect(); }, 12000);
    }
  }

  // ── Banner de cookies propio ──
  // Usa la API oficial de Shopify (consent-tracking-api) para que el consentimiento
  // quede registrado de verdad: de eso dependen el pixel de Meta y el cumplimiento.
  var ck = document.getElementById('ckBanner');
  if (ck && window.Shopify && window.Shopify.loadFeatures) {
    var mostrar = function () { ck.hidden = false; requestAnimationFrame(function () { ck.classList.add('ver'); }); };
    var ocultar = function () {
      ck.classList.remove('ver');
      setTimeout(function () { ck.hidden = true; }, 320);
    };

    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (err) { return; } // Sin la API no se muestra nada: mejor eso que un banner que no registra
      var privacidad = window.Shopify.customerPrivacy;
      if (!privacidad) return;

      // Solo se pregunta a quien aún no ha respondido
      try { if (privacidad.shouldShowBanner && !privacidad.shouldShowBanner()) return; } catch (e) {}
      mostrar();

      ck.querySelectorAll('[data-ck]').forEach(function (b) {
        b.addEventListener('click', function () {
          var acepta = b.dataset.ck === 'aceptar';
          try {
            privacidad.setTrackingConsent({
              analytics: acepta,
              marketing: acepta,
              preferences: acepta,
              sale_of_data: acepta
            }, ocultar);
          } catch (e) { ocultar(); }
          setTimeout(ocultar, 600); // por si la API no devuelve el callback
        });
      });
    });
  }

  // ── Pop-up de descuento por correo ──
  // Escritorio: exit-intent. Móvil: por tiempo o scroll (ahí no hay "cursor saliendo").
  var pop = document.getElementById('popDesc');
  if (pop) {
    var LLAVE = 'gema_popup';
    var estado = {};
    try { estado = JSON.parse(localStorage.getItem(LLAVE) || '{}'); } catch (e) { estado = {}; }

    var yaSuscrito = estado.suscrito === true;
    var vistoHace = estado.visto ? (Date.now() - estado.visto) / 86400000 : 999; // días
    var exito = !!pop.querySelector('.pop-ok');

    function guardar(o) {
      try { localStorage.setItem(LLAVE, JSON.stringify(Object.assign(estado, o))); } catch (e) {}
    }
    function abrir() {
      if (pop.hidden === false) return;
      pop.hidden = false;
      document.body.classList.add('nav-lock');
      guardar({ visto: Date.now() });
      var campo = pop.querySelector('input[type=email]');
      if (campo) setTimeout(function () { campo.focus(); }, 350);
    }
    function cerrar() {
      pop.hidden = true;
      document.body.classList.remove('nav-lock');
    }

    // Si el visitante acaba de dejar su correo, se abre solo para mostrarle el código.
    if (exito) { guardar({ suscrito: true }); abrir(); }

    // Solo se ofrece a quien no se ha suscrito y no lo vio en los últimos 7 días.
    if (!exito && !yaSuscrito && vistoHace > 7) {
      var disparado = false;
      var lanzar = function () { if (!disparado) { disparado = true; abrir(); } };

      if (window.matchMedia('(min-width: 768px)').matches) {
        document.addEventListener('mouseout', function (e) {
          if (!e.relatedTarget && e.clientY < 12) lanzar();
        });
      } else {
        setTimeout(lanzar, 30000); // 30 s navegando
        window.addEventListener('scroll', function () {
          var h = document.documentElement;
          if ((h.scrollTop + window.innerHeight) / h.scrollHeight > 0.55) lanzar();
        }, { passive: true });
      }
    }

    pop.querySelector('.pop-x').addEventListener('click', cerrar);
    pop.addEventListener('click', function (e) { if (e.target === pop) cerrar(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) cerrar(); });

    var copiar = pop.querySelector('.pop-copiar');
    if (copiar) {
      copiar.addEventListener('click', function () {
        var codigo = pop.querySelector('.pop-codigo').dataset.codigo;
        var listo = function () { copiar.textContent = '✓'; setTimeout(function () { copiar.textContent = copiar.dataset.txt || 'Copiar'; }, 1800); };
        copiar.dataset.txt = copiar.dataset.txt || copiar.textContent;
        if (navigator.clipboard) navigator.clipboard.writeText(codigo).then(listo).catch(function () {});
        else listo();
      });
    }
  }

  // Galería de producto: cambiar imagen principal al hacer clic en miniatura
  var main = document.querySelector('.p-gallery .main img');
  var mainBox = document.querySelector('.p-gallery .main');
  if (main) {
    document.querySelectorAll('.p-gallery .thumbs a').forEach(function (a) {
      a.addEventListener('click', function (ev) {
        ev.preventDefault();
        mainBox.classList.add('swapping');
        setTimeout(function () {
          main.onload = function () { mainBox.classList.remove('swapping'); };
          main.src = a.href;
          // Recorte → fondo negro con halo; foto original → caja clara
          mainBox.classList.toggle('main-cut', a.hasAttribute('data-th-cut'));
          if (main.complete) mainBox.classList.remove('swapping');
        }, 220);
        document.querySelectorAll('.p-gallery .thumbs a').forEach(function (x) { x.classList.remove('on'); });
        a.classList.add('on');
      });
    });
    // Zoom con el cursor (solo mouse): el punto que miras es el que se amplía
    if (window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
      mainBox.addEventListener('mousemove', function (e) {
        var r = mainBox.getBoundingClientRect();
        main.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
      mainBox.addEventListener('mouseenter', function () { mainBox.classList.add('zooming'); });
      mainBox.addEventListener('mouseleave', function () { mainBox.classList.remove('zooming'); });
    }
  }

  // ── Header inteligente: sólido tras el hero, se esconde al bajar y vuelve al subir ──
  var hdr = document.querySelector('[data-header]');
  if (hdr) {
    var prog = hdr.querySelector('[data-hprog]');
    var lastY = window.scrollY, ticking = false;
    var leerScroll = function () {
      var y = window.scrollY;
      hdr.classList.toggle('solid', y > 40);
      if (y > lastY + 4 && y > 260) hdr.classList.add('hide');
      else if (y < lastY - 4 || y <= 260) hdr.classList.remove('hide');
      lastY = y;
      if (prog) {
        var total = document.documentElement.scrollHeight - window.innerHeight;
        prog.style.transform = 'scaleX(' + (total > 0 ? Math.min(y / total, 1) : 0) + ')';
      }
      ticking = false;
    };
    leerScroll();
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(leerScroll); }
    }, { passive: true });
  }

  // ── Barra fija inferior en la ficha (móvil): aparece cuando el botón principal ya pasó ──
  var stickyBuy = document.querySelector('[data-sticky-buy]');
  var addMain = document.querySelector('[data-add-main]');
  if (stickyBuy && addMain && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      var e = en[0];
      var pasado = !e.isIntersecting && e.boundingClientRect.top < 0;
      stickyBuy.classList.toggle('ver', pasado);
      stickyBuy.setAttribute('aria-hidden', !pasado);
      document.body.classList.toggle('sb-on', pasado);
    }, { threshold: 0 }).observe(addMain);
  }

  // ══════════════════════════════════════════════════════════════
  // Cart drawer: agregar, cambiar cantidad y quitar sin salir de la página.
  // El HTML lo renderiza Shopify (Section Rendering API: /?sections=cart-drawer),
  // así los precios, descuentos y la barra de envío siempre son los reales.
  // ══════════════════════════════════════════════════════════════
  var cdWrap = document.getElementById('shopify-section-cart-drawer');
  if (cdWrap) {
    var lenisPausa = function (on) {
      var L = window.__lenis; if (!L) return;
      if (on) L.stop(); else L.start();
    };
    var cdAbrir = function () {
      document.body.classList.add('cd-open');
      lenisPausa(true);
      var x = cdWrap.querySelector('.cd-x'); if (x) setTimeout(function () { x.focus(); }, 400);
    };
    var cdCerrar = function () {
      document.body.classList.remove('cd-open');
      lenisPausa(false);
    };
    var toast = document.createElement('div');
    toast.className = 'cd-toast';
    document.body.appendChild(toast);
    var toastTimer;
    var avisar = function (txt) {
      toast.textContent = txt;
      toast.classList.add('ver');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.classList.remove('ver'); }, 2200);
    };
    var contar = function (n) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = n;
        el.setAttribute('data-cart-count', n);
        el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
      });
    };
    var cdRefrescar = function () {
      // Siempre desde la raíz (con prefijo de idioma si lo hay): en /products/x Shopify
      // interpreta la petición como el JSON del producto y no devuelve la sección.
      var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(raiz + '?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var tmp = document.createElement('div');
          tmp.innerHTML = j['cart-drawer'];
          var nuevo = tmp.firstElementChild;
          cdWrap.innerHTML = nuevo ? nuevo.innerHTML : tmp.innerHTML;
          var aside = cdWrap.querySelector('.cd');
          if (aside) contar(aside.getAttribute('data-count') || 0);
        });
    };
    var cambiarLinea = function (item, qty) {
      item.classList.add('is-busy');
      return fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.getAttribute('data-key'), quantity: qty })
      }).then(function (r) { if (!r.ok) throw new Error('change'); return cdRefrescar(); })
        .catch(function () { item.classList.remove('is-busy'); });
    };

    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-cart-open], [data-cd-close], [data-qty], [data-remove]');
      if (!t) return;
      if (t.hasAttribute('data-cart-open')) { e.preventDefault(); cdAbrir(); return; }
      if (t.hasAttribute('data-cd-close')) { if (t.tagName !== 'A') e.preventDefault(); cdCerrar(); return; }
      if (t.hasAttribute('data-qty')) {
        var item = t.closest('.cd-item');
        var actual = parseInt(item.querySelector('.cd-qty span').textContent, 10) || 0;
        cambiarLinea(item, Math.max(0, actual + parseInt(t.getAttribute('data-qty'), 10)));
        return;
      }
      if (t.hasAttribute('data-remove')) { e.preventDefault(); cambiarLinea(t.closest('.cd-item'), 0); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.classList.contains('cd-open')) cdCerrar();
    });

    // Agregar por AJAX: tarjetas (quick add), upsell del drawer y formulario de la ficha
    var agregando = false;
    var agregar = function (form, btn) {
      if (agregando) return;
      agregando = true;
      var lbl = btn && (btn.querySelector('.qa-lbl') || btn.querySelector('.btn-txt') || btn);
      var txtOriginal = btn ? btn.getAttribute('data-txt') || lbl.textContent : '';
      if (btn) { btn.classList.add('is-busy'); btn.disabled = true; }
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('add'); return cdRefrescar(); })
        .then(function () {
          if (btn) {
            btn.classList.remove('is-busy'); btn.classList.add('is-ok'); btn.disabled = false;
            if (lbl && btn.getAttribute('data-ok')) lbl.textContent = btn.getAttribute('data-ok');
            setTimeout(function () { btn.classList.remove('is-ok'); if (lbl && txtOriginal) lbl.textContent = txtOriginal; }, 1800);
          }
          var aside = cdWrap.querySelector('.cd');
          avisar(aside && aside.getAttribute('data-toast') || '◆');
          cdAbrir();
        })
        .catch(function () {
          if (btn) { btn.classList.remove('is-busy'); btn.disabled = false; }
          form.submit(); // sin AJAX, Shopify lleva al carrito clásico
        })
        .then(function () { agregando = false; });
    };
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (f.matches('[data-quick-add]')) { e.preventDefault(); agregar(f, f.querySelector('button')); return; }
      // Ojo: form.id NO sirve aquí — el <input name="id"> lo pisa. Hay que leer el atributo.
      if (f.getAttribute('id') === 'formProducto') { e.preventDefault(); agregar(f, f.querySelector('[data-add-main]')); }
    });
  }
})();
